
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import * as Articulos from '@lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Articulo } from '@/__env/lib/Articulos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public get Seleccionados() { return this.Controlador.Seleccionados; }
        @Watch( 'Seleccionados' )
        onSeleccionados()
        {
            if ( this.Seleccionados.hasRows() )
            {
                this.SubModo = '';
                this.Abierto = true;
            }
            else
                this.Abierto = false;
        }
        public Abierto: boolean = false;

        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Articulos: Articulo[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Articulos.Tipos.toTipo( a ), Articulos: items[a] } );
            }
            return e;
        }

        public SubModo: string = '';


        Cerrar()
        {
            this.Seleccionados.clear();
        }
    }
